import {
  Heading,
  Text,
  Flex,
  UnorderedList,
  ListItem,
  Divider,
} from "@chakra-ui/react";
import GameTable from "./GameTable";
import Scoring from "./Scoring";
import React from "react";
import { nanoid } from "nanoid";

const Rule = ({ heading, bulletPoints, text, divider, marginTop }) => {
  const listItems = bulletPoints.map((point, i) => {
    if (typeof point === "object") {
      return (
        <React.Fragment key={nanoid()}>
          <ListItem fontSize="md" margin="10px 35px" lineHeight={2}>
            Certain cards are worth a specific amount of game points:
          </ListItem>
          <GameTable />
        </React.Fragment>
      );
    }
    if (
      bulletPoints[0] ===
      "There are two ways to score points in the game of Setback:"
    ) {
      return (
        <React.Fragment key={nanoid()}>
          <ListItem
            fontSize="md"
            margin="10px 35px"
            key={nanoid()}
            lineHeight={2}
          >
            {point}
          </ListItem>
          <Scoring />
        </React.Fragment>
      );
    }
    return (
      <ListItem fontSize="md" key={nanoid()} margin="10px 35px" lineHeight={2}>
        {point}
      </ListItem>
    );
  });
  return (
    <Flex direction="column" gap={"10px"}>
      <Heading size="md" marginTop={marginTop}>
        {heading}
      </Heading>
      {bulletPoints && <UnorderedList>{listItems}</UnorderedList>}
      {text && <Text>{text}</Text>}
      {divider === "true" && <Divider margin={2} />}
    </Flex>
  );
};
export default Rule;
